<div class="course-info-card">
  <div class="course-info-card__header">
    <div class="course-info-card__header-left">
      <div class="course-info-card__title">
        {{ 'app.components.courseCreator.publish.courseInformation' | translate }}
      </div>
      <img src="/public/svgs/edit.svg" alt="Edit">
    </div>
  </div>

  <div class="course-info-card__card">
    @for (row of courseInfoRows(); track row.id) {
      <div class="course-info-card__row" [class]="row.customClass">
        @if (row.isSpecial && row.id === 'tags') {
          <!-- Special case: Tags row -->
          <div class="course-info-card__tags">
            @for (tag of tags(); track $index) {
              <div class="course-info-card__badge course-info-card__badge--grey">
                <div class="course-info-card__badge-content">
                  <div class="course-info-card__badge-text">{{ tag }}</div>
                </div>
              </div>
            }
          </div>
          <div class="course-info-card__label">{{ row.labelKey | translate }}</div>
        } @else if (row.type === 'field-label') {
          <!-- Field label rows -->
          <div class="course-info-card__field-label">
            @if (row.id === 'courseName') {
              {{ row.value }}
            } @else if (row.value) {
              {{ toString(row.value) | translate }}
            }
          </div>
          <div class="course-info-card__label">{{ row.labelKey | translate }}</div>
        } @else if (row.type === 'badge') {
          <!-- Badge rows -->
          <div class="course-info-card__badge" [class]="'course-info-card__badge--' + row.badgeColor">
            <div class="course-info-card__badge-content">
              <div class="course-info-card__badge-text">
                @if (row.id === 'duration') {
                  {{ row.value }} {{ 'app.components.courseCreator.publish.minutes' | translate }}
                } @else {
                  {{ row.value }}
                }
              </div>
            </div>
          </div>
          <div class="course-info-card__label">{{ row.labelKey | translate }}</div>
        }
      </div>
    }
  </div>
</div>

